import mitt from 'mitt'
import type { IEntityDataItem } from '~/types/models'

/**
 * Global `<entityName>Created` event bus, extracted for the Nuxt Bridge →
 * Nuxt 3 migration.
 *
 * Replaces the Nuxt-2 `this.$nuxt.$on/$off/$emit(...)` instance bus, which
 * Nuxt 3 removes. Like `$nuxt` (the single root Vue instance), this is one
 * module-level singleton shared app-wide — import it wherever the old
 * `$nuxt` bus calls lived: `FooterPlusSignMenu.vue` emits
 * `<entityName>Created` after an entity is created, and `ListPage.vue` /
 * `ActivitiesMixin.ts` listen so already-mounted lists pick up the new
 * entity.
 *
 * The event map types every `` `${string}Created` `` event as carrying the
 * created entity (an `IEntityDataItem` subtype) as its payload. Note that
 * mitt's `off(type)` with the handler argument omitted removes ALL handlers
 * for that type, matching the old `$nuxt.$off('event')` semantics exactly.
 */
type TEntityCreatedEvents = Record<`${string}Created`, IEntityDataItem>

/** The app-wide singleton bus instance. */
export const eventBus = mitt<TEntityCreatedEvents>()
